export default __webpack_public_path__ + "images/5f3fd53fb6dcb72124c92a762df11a88-softball.webp";